import { useEffect } from 'react';
import { VerticalLayout } from '../../common/common-layout';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import { useHideMenu } from '../../hooks/useHideMenu';
import { useScrollMenuHandler } from '../../hooks/useScrollMenuHandler';
import menuStore from '../../store/MenuStore';
import FooterSection from '../base/FooterSection';
import FooterSectionMobile from '../base/FooterSectionMobile';
import PrivacyPolicySection2 from './PrivacyPolicySection2';
import TermsHeader from './TermsHeader';

const PrivacyPolicyMainPage = () => {
  const { isMobile } = useDeviceType();
  useScrollMenuHandler();
  useHideMenu();

  useEffect(() => {
    menuStore.setBackgroundColor('transparent');
  }, []);
  

  return (
    <VerticalLayout>
      <TermsHeader />
      <PrivacyPolicySection2 />
      <div style={{ width: '100%', overflowX: 'hidden' }}>
        {isMobile ? <FooterSectionMobile /> : <FooterSection />}
      </div>
    </VerticalLayout>
  );
};

export default PrivacyPolicyMainPage;
